"use client"

import { Ampersand } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AmpersandIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AmpersandIcon = component(Icon)({ as: Ampersand })
